import styled from 'styled-components';
import { p, px } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';

export const StyledCover = styled.div`
  ${p(2)};
  ${breakpoint('mobile', 'desktop')`
  .control-arrow.control-next.control-disabled{
display: none !important;
  }
  .control-arrow.control-prev.control-disabled{
    display: none !important;
  }
  ${px(1)};
  padding-bottom: 4rem`}
`;

export const StyledTopHeader = styled.div`
  background-color: #7ccde9;
  color: ${theme.colors.white};
  font-size: 25px;
  font-weight: bold;
  ${p(4)};
  display: flex;
  flex-direction: row;
`;

export const StyledImageWrapper = styled.div``;

export const StyledCarouselChild = styled.div`
  width: 90%;
  aspect-ratio: 1;
  align-self: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0px !important;
  }
`;

export const StyledTopImageWrapper = styled.div`
  aspect-ratio: 1;
  height: 400px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: auto;
  ${breakpoint('desktop')`
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    object-position: center;
  `}
`;
